import { LoggedUser } from "../../../redux/store";
import { Account } from "@idha/idha-types";

export abstract class ModulePermissions {
    constructor() { }    
}

export abstract class PermissionsPipeData<T extends ModulePermissions> {
    permissions: T
    loggedUser: LoggedUser

    constructor(loggedUser: LoggedUser, permissions: T) {
        this.permissions = permissions;
        this.loggedUser = loggedUser;
    }

    disableAllKeys?() {
        for (var key in this.permissions) {
            if(typeof this.permissions[key] == 'boolean'){
                (<any>this.permissions[key]) = false;
            }
        }
    }
}

export function disableAllKeys(permissions: ModulePermissions): ModulePermissions {
    let result = {};
    for (var key in permissions) {
        result[key] = false;
    }
    return <any>result;
}